<template>
        <card>
            <template slot="header">
                <h3 class="card-title">ESS Account Creations</h3>
            </template>
            <nav class="row">
                <ol class="breadcrumb arr-right bg-breadcrum">
                    <li class="breadcrumb-item">
                        <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/hr/users">Users</router-link>
                    </li>
                    <li class="breadcrumb-item active">Create account</li>
                </ol>
            </nav>
            <hr style="margin-top:-10px" />
            <br/>
            <form @submit="formSubmit">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <p class="p-text">Employees List:</p>
                            <select class="form-control" v-model="employee_id" required>
                                <option value="">-- Select Employee --</option>
                                <option v-for="emp in employees" v-bind:value="emp.id">{{emp.full_name}}</option>
                            </select>
                        </div>
                       
                        <div class="form-group">
                            <p class="p-text">Username :</p>
                            <input type="text" v-model="username" @keyup="concat_email" class="form-control"  required>
                        </div>
                        <div class="form-group">
                                <p class="p-text">Company Email :</p>
                                <input type="email" v-model="email" class="form-control" required>
                            </div>
                        <div class="form-group">
                            <p class="p-text">Default Password :</p>
                            <input type="text" v-model="password" class="form-control">
                        </div>
                        <div class="form-group">
                            <p class="p-text">Select Roles :</p>
                            <select class="form-control" v-model="user_roles" required>
                                <option value="">-- Select Roles --</option>
                                <option v-for="r in roles" v-bind:value="r.id">{{r.roles_name}}</option>
                            </select>
                        </div>
                        <div v-if="user_roles === 1">
                            <div class="form-group">
                                <p class="p-text">Belongs to</p>
                                <select class="form-control" v-model="assign_to" @change="get_belongs">
                                    <option value="">--Select One--</option>
                                    <option value="admin">Belongs to ADMIN</option>
                                    <option value="supervisor">Belongs to SUPERVISOR</option>
                                </select>
                            </div>
                        </div>
                        <div v-if="user_roles === 2">
                            <div class="form-group">
                                <p class="p-text">Belongs To :</p>
                                <select class="form-control" v-model="belongs_to" @change="get_operation">
                                    <option value="">-- Select Manager --</option>
                                    <option v-for="op in operations" v-bind:value="op.id"><b>{{op.full_name | capitalize}}</b> - {{op.position_name | capitalize}}</option>
                                </select>
                            </div>
                        </div>
                        <div v-if="assign_to === 'supervisor' && user_roles === 1" >
                            <div class="form-group">
                                <p class="p-text">Supervisor:</p>
                                <select class="form-control" v-model="belongs_to" @change="get_superiorname">
                                    <option value="">-- Select Supervisor --</option>
                                    <option v-for="sup in supervisor" v-bind:value="sup.id"><b>{{sup.full_name | capitalize}}</b> - {{sup.position_name | capitalize}}</option>
                                </select>
                            </div>
                        </div>
                        <div v-if="user_roles === 3">
                             <p class="p-text">Select team to handle :</p>
                             <h6>SUB DEPARTMENT / SUBORDINATES</h6>
                             <div class="subordinatesSytle mt-3">
                                <div v-for="item in sub_department_item">
                                    <input type="checkbox" v-model="subordinates" v-bind:value="item.id">
                                    <label for="vehicle1">{{item.sub_department_name}}</label><br>
                                </div>
                             </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-primary mt-4"><i class="fa fa-location-arrow"></i> Create Account</button>
                <br/>
                <br/>
                <br/>
            </form>
        </card>
    </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'  
export default {
   components: {
      Card,
   },
   data() {
      return {
        roles:[],
        employees:[],
        supervisor:[],
        operations:[],
        user_roles:'',
        belongs_to:'',
        employee_id:'',
        username:'',
        email:'',
        superior_name:{},
        password:'Blueprint@111',
        error_handler:[],
        assign_to:'',
        sub_department_item:[],
        subordinates:[]
      }
   },
   mounted: function() {
        this.get_roles()
        this.get_employees()
        this.get_supervisor()
        this.get_superiorname()
        this.get_belongs()
        this.get_operation()
        this.get_sub_department()
   },
   methods: {
      concat_email(){
         if(this.username.length == 0){
             this.email = ""
         }else{
            this.email = this.username + "@blueprintbusinesssolutionscorp.com"  
         }
       
        
         console.log("test",this.email)
      },
      get_sub_department(){
          axios.get('api/subdepartment/all')
                .then(response => {  this.sub_department_item = response.data;  })  
                .catch(error => {  console.log(error.response)  });
       },

       get_belongs(){
              if(this.assign_to == 'admin'){
                    this.superior_name = ({'full_name':'ADMIN'})
                    console.log(this.superior_name)  
              }
       },

        get_employees(){
           axios.get('api/employeenotregistered')
                .then(response => {  this.employees = response.data; })  
                .catch(error => {  console.log(error.response)  });
        },

        get_superiorname(){
           if(this.assign_to == 'supervisor' && this.belongs_to != ''){
                axios.get('api/superiorname/get/'+ this.belongs_to)
                .then(response => {  this.superior_name = response.data;})  
                .catch(error => {  console.log(error.response)  });
            }
        },

        get_operation(){
               axios.get('api/operation')
                .then(response => {  this.operations = response.data;})  
                .catch(error => {  console.log(error.response)  });
        },
        
        get_supervisor(){
             axios.get('api/supervisor')
                .then(resp => { this.supervisor = resp.data; })
                .catch(error => { console.log(error.response) });
        },

        get_roles(){
             axios.get('api/allroles')
                .then(response => { this.roles = response.data; })
                .catch(error => { console.log(error.response)});
            },
                
        formSubmit(e){
            e.preventDefault();

            console.log(this.subordinates)
            this.$swal({
                    title: 'Are you sure?',
                    text: 'Do you want to register new user',
                    type: 'warning',
                    showCancelButton: true,
                    showCloseButton: false,
                })
            .then((isConfirm) => {
                if(isConfirm === true) {
                    axios.post('api/register',{
                                role_id:this.user_roles,
                                name:this.username,
                                email:this.email,
                                password:this.password,
                                superior_name:this.superior_name.full_name,
                                employee_id:this.employee_id,
                                belongs_to:this.belongs_to,
                                subordinates: JSON.stringify(this.subordinates)
                            })
                            .then(resp => {
                            if(resp.data.response == 'success'){
                                this.$swal('Save', resp.data.message , 'success')
                                this.$router.push({name: 'users'}) 
                                this.username = ''
                                this.password = ''

                            }else if(resp.data.response == 'error'){
                                this.$swal('Error',resp.data.message,'error')
                            }                   
                        })    
                        .catch(error => {
                            // if (error.response.status == 422){
                            //      this.error_handler = error.response.data.error_pointer  
                            // }
                            console.log(error); 
                        }); 
                    }
                }); 
        }
     },
     computed: {
             
     },

}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-users/todo-account-user.vue